
export function getToken(state) {
    return state.auth.data ? state.auth.data.user.token : null;
}
